import { Momento } from "./types";

export const MOMENTOS: Momento[] = [
  {
    slug: "vida-independiente",
    nombre: "Vida independiente",
    frase: "Tu primer contrato, tu primer hogar, tus primeras decisiones.",
    intro:
      "Empiezas a firmar contratos, a rentar, a trabajar y a administrar tu propio dinero. Cada firma nueva es una relación legal nueva, y entenderla a tiempo evita problemas caros.",
    situaciones: [
      "Vas a rentar un lugar por primera vez y te piden firmar de inmediato",
      "Te presentan un contrato que no entiendes del todo",
      "Empiezas a trabajar y tienes dudas sobre tu contrato o tus pagos",
      "Te cobran algo que crees que no corresponde",
      "Quieres empezar a ordenar tus documentos y cuentas",
    ],
    comoAyudamos: [
      "Revisamos contratos antes de que los firmes y te explicamos cada cláusula",
      "Te decimos qué documentos pedir y qué conservar desde el inicio",
      "Te acompañamos si algo sale mal con arrendador, proveedor o empleador",
    ],
    serviciosRelacionados: ["proteccion-del-consumidor", "defensa-laboral", "proteccion-digital"],
    seoTitle: "Vida independiente",
    seoDesc:
      "Renta, contratos, primer trabajo y primeras firmas: orientación legal clara para tu vida independiente.",
  },
  {
    slug: "vida-en-pareja",
    nombre: "Vida en pareja",
    frase: "Compartir vida también es compartir decisiones.",
    intro:
      "Vivir juntos, comprar juntos, casarse o separarse implican decisiones con consecuencias legales. Poner claridad temprano protege a las dos personas, incluso en el mejor de los escenarios.",
    situaciones: [
      "Van a vivir juntos y quieren claridad sobre gastos y bienes",
      "Planean casarse y quieren entender separación o sociedad conyugal",
      "Compraron bienes en común y quieren formalizarlo",
      "La relación terminó y hay que dividir o definir",
      "Quieren acuerdos claros sin que sea un tema de desconfianza",
    ],
    comoAyudamos: [
      "Explicamos las implicaciones legales de cada arreglo antes de decidirlo",
      "Redactamos acuerdos que las dos partes entienden y pueden sostener",
      "Acompañamos procesos de separación priorizando acuerdos sobre conflicto",
    ],
    serviciosRelacionados: ["familia-y-acuerdos", "bienes-y-patrimonio"],
    seoTitle: "Vida en pareja",
    seoDesc:
      "Acuerdos de pareja, matrimonio, bienes en común y separaciones: claridad legal para decisiones de dos.",
  },
  {
    slug: "hijos-y-crianza",
    nombre: "Hijos y crianza",
    frase: "Decisiones que los protegen a ellos y a ustedes.",
    intro:
      "Tener hijas e hijos mueve todo: la economía, la vivienda, el trabajo y las responsabilidades. El derecho puede ser una herramienta de protección cuando las decisiones están bien tomadas.",
    situaciones: [
      "Va a nacer un hijo y quieren planear lo que viene",
      "Custodia y convivencia después de una separación",
      "Pensión alimenticia: cuánto, cómo y qué cubre",
      "Reconocimiento, adopción o nueva figura parental",
      "Datos y privacidad de menores en dispositivos y redes",
    ],
    comoAyudamos: [
      "Explicamos tus obligaciones y derechos con lenguaje claro",
      "Priorizamos acuerdos que protejan el interés de las niñas y niños",
      "Te acompañamos en trámites y, cuando procede, en procesos judiciales",
    ],
    serviciosRelacionados: ["familia-y-acuerdos", "proteccion-digital"],
    seoTitle: "Hijos y crianza",
    seoDesc:
      "Custodia, pensión alimenticia, adopción y protección de menores: acompañamiento legal para familias.",
  },
  {
    slug: "vivienda-y-patrimonio",
    nombre: "Vivienda y patrimonio",
    frase: "La casa y lo construido, en orden.",
    intro:
      "Comprar una casa, rentar a largo plazo o heredar un inmueble son de las operaciones más grandes de una vida. Revisar bien los documentos antes vale más que cualquier remedio después.",
    situaciones: [
      "Compra o venta de una casa o departamento",
      "Renta con problemas: depósito retenido, incumplimientos, desalojo",
      "Escrituras pendientes, antecedentes irregulares o bienes sin titularizar",
      "Herencia de un inmueble entre familiares",
      "Prevención de fraudes inmobiliarios o de venta de humo",
    ],
    comoAyudamos: [
      "Revisamos títulos, antecedentes y adeudos antes de cualquier firma",
      "Estructuramos la operación para que quede bien documentada",
      "Regularizamos y defendemos la propiedad cuando ya hay un problema",
    ],
    serviciosRelacionados: ["bienes-y-patrimonio", "familia-y-acuerdos"],
    seoTitle: "Vivienda y patrimonio",
    seoDesc:
      "Compra-venta, renta, escrituras y herencias de inmuebles: protección legal para tu patrimonio.",
  },
  {
    slug: "trabajo-y-negocio",
    nombre: "Trabajo y negocio",
    frase: "Del empleo propio al negocio que crece.",
    intro:
      "Formalizar un negocio, firmar con clientes o resolver un problema laboral: el trabajo y la empresa mueven documentos, plazos y responsabilidades que conviene tener controlados.",
    situaciones: [
      "Quieres formalizar un negocio o empezar a facturar",
      "Despido, renuncia o adeudos con derechos en juego",
      "Contratos con clientes, socios o proveedores sin revisar",
      "Acuerdos entre socios que viven solo en confianza",
      "Problemas con trabajadores o con el patrón",
    ],
    comoAyudamos: [
      "Ordenamos la estructura legal de tu negocio según su etapa real",
      "Defendemos derechos laborales de trabajadores y de empleadores que quieren cumplir",
      "Documentamos decisiones importantes para que el crecimiento no genere riesgo",
    ],
    serviciosRelacionados: ["asesoria-de-negocios", "defensa-laboral"],
    seoTitle: "Trabajo y negocio",
    seoDesc:
      "Formalización, contratos, socios y problemas laborales: asesoría legal para trabajar y emprender.",
  },
  {
    slug: "cambios-de-vida",
    nombre: "Cambios de vida",
    frase: "Cuando la vida da giros, hay que reordenar.",
    intro:
      "Una separación, un cambio de ciudad, una enfermedad o un nuevo rumbo profesional trae papeleo y decisiones que no pueden esperar para siempre. Reordenar a tiempo reduce el desgaste.",
    situaciones: [
      "Separación o divorcio, con o sin acuerdo",
      "Cambio de ciudad o de país con bienes y obligaciones pendientes",
      "Enfermedad o incapacidad propia o de un familiar",
      "Cambio de empleo o de actividad económica",
      "Deudas y gastos que dejaron de cuadrar",
    ],
    comoAyudamos: [
      "Identificamos qué se puede resolver por acuerdo y qué requiere formalidad",
      "Priorizamos lo urgente y ordenamos lo importante",
      "Actualizamos documentos y contratos para que reflejen tu nueva situación",
    ],
    serviciosRelacionados: ["familia-y-acuerdos", "bienes-y-patrimonio"],
    seoTitle: "Cambios de vida",
    seoDesc:
      "Separaciones, mudanzas, salud y reorganización: acompañamiento legal en los giros de la vida.",
  },
  {
    slug: "cuidados-y-autonomia",
    nombre: "Cuidados y autonomía",
    frase: "Cuidar y ser cuidado, con reglas claras.",
    intro:
      "Cuidar a personas mayores o con dependencia implica decisiones económicas, médicas y familiares. Ponerlas en orden evita conflictos entre quienes quieren ayudar.",
    situaciones: [
      "Cuidado de personas mayores: gastos, vivienda y responsabilidades",
      "Tutorías y representación legal de quien ya no puede decidir sola",
      "Decisiones médicas y voluntades anticipadas",
      "Sospecha de abuso o negligencia en el cuidado",
      "Acuerdos familiares sobre quién asume qué",
    ],
    comoAyudamos: [
      "Formalizamos representaciones y acuerdos de cuidado con claridad",
      "Protegemos el patrimonio de la persona cuidada y de quien cuida",
      "Intervenimos con firmeza cuando hay señales de abuso o negligencia",
    ],
    serviciosRelacionados: ["familia-y-acuerdos", "bienes-y-patrimonio"],
    seoTitle: "Cuidados y autonomía",
    seoDesc:
      "Cuidado de personas mayores, representación legal y voluntades anticipadas, con reglas claras.",
  },
  {
    slug: "legado-y-sucesion",
    nombre: "Legado y sucesión",
    frase: "Lo que dejas, bien ordenado.",
    intro:
      "Un testamento oportuno es un acto de cariño práctico: evita que quienes quedan tengan que resolver tus asuntos en el peor momento. Y si ya toca sucesionar, ordenarlo bien ahorra años.",
    situaciones: [
      "Quieres hacer un testamento y no sabes por dónde empezar",
      "Falleció un familiar y hay bienes que ordenar",
      "Sucesiones entre hermanos o familiares con posiciones distintas",
      "Bienes de la familia sin titularizar o con documentos viejos",
      "Donaciones o adelantos de herencia que conviene formalizar",
    ],
    comoAyudamos: [
      "Hacemos testamentos sencillos de entender y de mantener actualizados",
      "Conducimos sucesiones con diálogo entre familiares y plazos reales",
      "Regularizamos la titularidad de bienes para que el legado llegue completo",
    ],
    serviciosRelacionados: ["bienes-y-patrimonio", "familia-y-acuerdos"],
    seoTitle: "Legado y sucesión",
    seoDesc:
      "Testamentos, sucesiones y regularización de bienes: ordena tu legado con claridad.",
  },
];

export const momentoBySlug = (slug?: string) => MOMENTOS.find((m) => m.slug === slug);
